import { Alert, AlertModal } from '../../..'
import { observer } from 'mobx-react-lite'
import { Icons } from '../../../misc/Icons'
import { store } from '../../../stores/Store'
import PanelBody from '../../layout/PanelBody'
import PanelHeader from '../../layout/PanelHeader'
import { Button, IconButton } from '@mui/material'
import ErrorBoundary from '../../../misc/ErrorBoundary'
import React from 'react'
import WorkflowTemplateList from './WorkflowTemplateList'
import WorkflowTemplateForm from './WorkflowTemplateForm'
import WorkflowTemplate from './WorkflowTemplate'
import Ajax from '../../../Ajax'


export default observer(function WorkflowTool () {
    
    const [workflow, setWorkflow] = React.useState(null)

    React.useEffect(() => {
        if (workflow) {
            var newWorkflow = store.AppStore.workflows?.find(wf => wf.uid === workflow?.uid)
            setWorkflow(newWorkflow)
        }
    }, [store.AppStore.workflows])
    
    return (
        <ErrorBoundary>
            <div className="panel panel-dark">
                <PanelHeader>
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        {workflow ? (
                            <h2>{workflow.label}</h2>
                        ) : (
                            <h2>Workflows</h2>
                        )}
                        
                        {workflow ? (
                            <Button
                                className="btn-sm"
                                color="success"
                                variant="contained"
                                onClick={() => setWorkflow(null)}>
                                <Icons.DoubleArrow style={{transform: "rotateZ(180deg)"}} /> Back to Workflow list
                            </Button>
                        ) : null}
                    </div>
                    
                    <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
                </PanelHeader>
                
                <PanelBody>
                    <div style={{width: "100%", overflowY: "auto", paddingBottom: "30px"}}>
                        {workflow ? (
                            <WorkflowTemplate workflow={workflow} />
                        ) : null}

                        {!workflow ? (
                            <div style={{maxWidth: "800px", display: "grid", gap: "20px"}}>
                                <p>Global Workflows are the standard Workflows which AORA provides for all users, however, you can create your own Workflows which can be used only by users under your account.</p>

                                <WorkflowTemplateList onSelect={(wf) => setWorkflow(wf)} />

                                <Button
                                    color="success"
                                    variant="contained"
                                    className="btn btn-sm"
                                    onClick={() => {
                                        AlertModal({title: "Create Workflow", body: <WorkflowTemplateForm />})
                                    }}>
                                    Create Workflow
                                </Button>    
                            </div>
                        ) : null}
                    </div>
                </PanelBody>
            </div>
        </ErrorBoundary>
    )
})